export default "__VITE_ASSET__DIfnDKH9__"